<app-dialog class="confirmation-dialog"
        [dialogWithInput]="dialog">
        <span style="font-size: 13px;" [innerHTML]="confirmationMessage"></span>

        <ng-container dialog-actions>
                <app-button *ngFor="let button of buttons"
                        color="primary"
                        [label]="button.label"
                        size="small"
                        (clickEvent)="close(button.value)"
                        fill="solid">
                </app-button>
        </ng-container>
</app-dialog>

